import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgDining = (props) => (
  <SvgIcon {...props} title="Dining">
    <svg
      viewBox="0 0 13 13"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m7.94 7 .84-.84c.933.4 2.213.093 3.167-.867 1.166-1.166 1.393-2.846.493-3.746-.893-.894-2.567-.674-3.747.493-.953.953-1.267 2.24-.86 3.173L1.466 11.58a.664.664 0 1 0 .94.94L7 7.94l4.586 4.587a.664.664 0 1 0 .94-.94L7.94 7ZM3.893 7.28l2.14-2.14-3.6-3.6a.676.676 0 0 0-1.066.153 3.012 3.012 0 0 0 .52 3.58L3.893 7.28Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default SvgDining;
